import { register } from "swiper/element";
// register Swiper custom elements
register();

import Swiper from "swiper/bundle";

export const aboutUs = new Swiper(".swiper-about-us", {
  loop: true,
  spaceBetween: 8,
  slidesPerView: 4,

  breakpoints: {
    1440: {
      slidesPerView: 4,
    },

    1024: {
      slidesPerView: 3,
    },

    768: {
      slidesPerView: 2,
    },

    280: {
      slidesPerView: 1,
    },
  },

  autoplay: {
    delay: 1800,
  },

  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
});

export const productsSlider = new Swiper(".products-swiper", {
  slidesPerView: "auto",
  spaceBetween: "12",
  speed: 1000,

  autoplay: {
    delay: 3500,
    disableOnInteraction: false,
    pauseOnMouseEnter: true,
  },

  breakpoints: {
    1440: {
      slidesPerView: 4.2,
    },

    768: {
      slidesPerView: 3.2,
    },

    490: {
      slidesPerView: 2.2,
      spaceBetween: "8",
    },

    280: {
      slidesPerView: 1.2,
      spaceBetween: "8",
    },
  },

  navigation: {
    nextEl: ".swiper-btn-next",
    prevEl: ".swiper-btn-prev",
  },
});

export const homePageSlider = new Swiper(".homepage-slider", {
  loop: true,
  slidesPerView: 1,

  autoplay: {
    delay: 3500,
  },

  speed: 1000,

  // navigation: {
  //   nextEl: ".swiper-button-next",
  //   prevEl: ".swiper-button-prev",
  // },
});
